import { createContext } from "react"

export interface TabBarTabContainerContextValue {
  index: number
  eventKey: string
  isDragging: boolean
  insertBefore: boolean
  insertAfter: boolean
}

export const TabBarTabContainerContext = createContext<
  TabBarTabContainerContextValue | undefined
>(undefined)
